import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import application from './modules/application'
import booking from './modules/booking'
import campground from './modules/campground'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

let hasSessionStorage = true
try {
  window.sessionStorage
} catch (e) {
  hasSessionStorage = false
}

let plugins = []
if (hasSessionStorage) {
  plugins = [createPersistedState({ storage: window.sessionStorage })]
}

export default new Vuex.Store({
  modules: {
    application,
    booking,
    campground,
  },
  strict: debug,
  plugins: plugins,
})
